import { useLenders } from '@axo/shared/data-access/hooks';
import { Tag, Tooltip } from '@blueprintjs/core';

interface Props {
  marketCountry: string;
  lenderID: string;
}

export function LenderName({ marketCountry, lenderID }: Props) {
  const lenders = useLenders(marketCountry);

  if (lenders.isLoading) {
    return <span>...</span>;
  }

  const lender = lenders?.data?.find(({ ID }) => ID === lenderID);

  if (!lender) {
    return <span>-</span>;
  }

  return (
    <Tooltip content={lender.Name}>
      <Tag minimal>{lender.ShortName}</Tag>
    </Tooltip>
  );
}
